import React from "react";
import 'bootstrap';
import useTranslation from "../hooks/useTranslation";
import {useAppData} from "../context/AppDataContext";

import "./AppInfo.scss";

const AppInfo = ({step}) => {
    const {t} = useTranslation();
    const {data} = useAppData();

    if (!step) {
        return null;
    }
    const period = data.period;
    let randomSelectionUsersForCourses = t("randomSelectionUsersForCourses");
    if (period.courseDrawDate && period.courseDrawDaysLimit) {
        const courseDrawDate = new Date(period.courseDrawDate);
        const courseDrawEnd = new Date(courseDrawDate.getTime() + period.courseDrawDaysLimit * 60 * 60 * 24 * 1000);
        randomSelectionUsersForCourses = randomSelectionUsersForCourses.replace("%drawCourseEndDate%", `${courseDrawEnd.toLocaleDateString()} ${courseDrawEnd.toLocaleTimeString()}`);
    }

    return (
        <div className={`alert alert-info AppInfo`} role="alert">
            <h3>{t(`appStep${step}`)}</h3>
            {step === 4 && <p>{randomSelectionUsersForCourses}</p>}
            <p>{t("totalRegisteredInSystem")}: {data.userCount}</p>
        </div>
    );
};

export default AppInfo;
